<template>
  <router-view/>
</template>

<script>
import { kickAgent } from '@/utils/agentSession'
import { kickUser, expireUser } from '@/utils/userSession'

export default {
  name: 'App',
  mounted () {
    window.addEventListener('agent-session-kicked', this.onAgentKicked)
    window.addEventListener('user-session-kicked', this.onUserKicked)
    window.addEventListener('user-session-expired', this.onUserSessionExpired)
  },
  beforeUnmount () {
    window.removeEventListener('agent-session-kicked', this.onAgentKicked)
    window.removeEventListener('user-session-kicked', this.onUserKicked)
    window.removeEventListener('user-session-expired', this.onUserSessionExpired)
  },
  methods: {
    onAgentKicked () {
      if (this.$route.name === 'agent-kicked') return
      kickAgent(this.$router)
    },
    onUserKicked () {
      if (this.$route.name === 'user-kicked') return
      kickUser(this.$router)
    },
    onUserSessionExpired () {
      if (this.$route.name === 'login') return
      expireUser(this.$router)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  --sidebar-width: 280px;
}

.main-content {
  margin-left: var(--sidebar-width) !important;
  transition: margin-left 0.3s ease;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0 !important;
  }
}
</style>
